module.exports = __webpack_public_path__ + "static/media/yesbitComLogo.876d35d2.png";